import { typographyCss } from '@creditornot/cb-ingredients';
import { Tag } from '@creditornot/cb-tag';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { MinimalOfferHeader } from './MinimalOfferHeader';
import { Offer, Option } from '../../types';
import { SectionTitle } from '../CommonPanelStyles';

type OfferLinksProps = {
  /** Will be undefined when creating a new option */
  activeOption?: Option;
  offersUsingCurrentOption: Offer[];
};

const EmptyList = styled.div`
  ${typographyCss.Body3};
`;

const Content = styled.div`
  margin: 24px;
`;

const StyledSectionTitle = styled(SectionTitle)`
  margin: 0 24px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledTag = styled(Tag).attrs({ variant: 'lightBlack' })`
  text-transform: uppercase;
`;

export const OfferLinks = ({ activeOption, offersUsingCurrentOption }: OfferLinksProps) => {
  return (
    <div>
      {!!activeOption && (
        <StyledSectionTitle>
          <FormattedMessage id="shared-menu.editor.option-panel.bound-items-title" />{' '}
          <StyledTag>{activeOption.name[0].value}</StyledTag>
        </StyledSectionTitle>
      )}
      {!offersUsingCurrentOption.length ? (
        <Content>
          <EmptyList>
            <FormattedMessage id="menu-option.no-links" />
          </EmptyList>
        </Content>
      ) : (
        <>
          {!!activeOption &&
            offersUsingCurrentOption.map(offer => (
              <MinimalOfferHeader key={offer.id} item={offer} activeOption={activeOption} />
            ))}
        </>
      )}
    </div>
  );
};
